export default (data: {[key: string]: string[]}, prefix?: string): string[] => {
  const errors: string[] = [];
  Object.values(data).forEach(errorArray => {
    errorArray.forEach(errorItem => {
      errors.push(prefix ? `${prefix} ${errorItem}` : errorItem)
    });
  })
  return errors;
}
